var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"text":_vm.$t('ClientUpdateButton:Text'),"size":"wide","color":"accentlines","icon":"retry","disabled":_vm.disabled,"is-loading":_vm.isUpdating,"loading-left":true},on:{"click":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }